import { z } from "zod"
import { betterDocSearchBaseSchema } from "@/modules/patients/detail/better-doc/schema/better-doc-search-base-schema"

export const betterDocSpecialistSearchSchema = betterDocSearchBaseSchema.extend({
  subSpecialty: z.string().optional(),
})

export type BetterDocSpecialistSearchFormSchema = z.infer<typeof betterDocSpecialistSearchSchema>
